function initMtReveal() {
  var elementos = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
  if (!elementos.length) return;
  var prefiereMenosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefiereMenosMovimiento) {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('mt-visible');
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  elementos.forEach(function (el) { observador.observe(el); });
}

function initMtCountdown() {
  var contadores = document.querySelectorAll('.mt-countdown');
  if (!contadores.length) return;

  function dosDigitos(n) {
    return String(n).padStart(2, '0');
  }

  function actualizar() {
    /* Medianoche de Puerto Rico (UTC-4 todo el año, sin horario de verano),
       sea cual sea la hora del dispositivo de quien mira la web. */
    var DIA_MS = 86400000;
    var OFFSET_PUERTO_RICO_MS = -4 * 3600000;
    var msEnPuertoRico = Date.now() + OFFSET_PUERTO_RICO_MS;
    var restante = DIA_MS - (((msEnPuertoRico % DIA_MS) + DIA_MS) % DIA_MS);

    var totalSegundos = Math.floor(restante / 1000) % 86400;
    var horas = Math.floor(totalSegundos / 3600);
    var minutos = Math.floor((totalSegundos % 3600) / 60);
    var segundos = totalSegundos % 60;

    contadores.forEach(function (contador) {
      var hEl = contador.querySelector('[data-mt-horas]');
      var mEl = contador.querySelector('[data-mt-min]');
      var sEl = contador.querySelector('[data-mt-seg]');
      if (hEl) hEl.textContent = dosDigitos(horas);
      if (mEl) mEl.textContent = dosDigitos(minutos);
      if (sEl) sEl.textContent = dosDigitos(segundos);
    });
  }

  actualizar();
  setInterval(actualizar, 1000);
}

function initMtAnuncioSticky() {
  var barra = document.querySelector('.announcement-bar');
  if (!barra) return;

  function medir() {
    var alto = barra.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--mt-anuncio-alto', alto + 'px');
  }

  medir();
  window.addEventListener('resize', medir);
  window.addEventListener('load', medir);
  if (window.ResizeObserver) {
    new ResizeObserver(medir).observe(barra);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initMtReveal();
  initMtCountdown();
  initMtAnuncioSticky();
});

/* ---------------------------------------------------------------
   Ventana del 10% (app EcomSend): sustituir su logo (con "MADRID")
   por el logo de la tienda sin "MADRID".
   --------------------------------------------------------------- */
(function () {
  var CM_LOGO = 'https://cdn.shopify.com/s/files/1/1068/3858/9772/files/carla-montiel-logo-transparente.png?width=240';
  var pending = false;
  function fixPopupLogo() {
    pending = false;
    var imgs = document.querySelectorAll('img.ecomsend__Modal__LogoImg, img[class*="ecomsend"][class*="LogoImg"]');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getAttribute('src') !== CM_LOGO) {
        imgs[i].removeAttribute('srcset');
        imgs[i].setAttribute('src', CM_LOGO);
        imgs[i].style.objectFit = 'contain';
      }
    }
  }
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (!pending) { pending = true; requestAnimationFrame(fixPopupLogo); }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', fixPopupLogo);
})();

/* ESTRELLAS DE LA FICHA: si el nombre ocupa 2+ líneas, bajarlas para que no lo pisen */
(function () {
  function cmFixRating() {
    var pos = document.querySelector('.cgm-rating-positioner');
    var h1 = document.querySelector('.product-information h1');
    if (!pos || !h1) return;
    var lh = parseFloat(getComputedStyle(h1).lineHeight) || 23;
    var extra = Math.max(0, h1.offsetHeight - lh - 2);
    pos.style.setProperty('top', Math.round(extra) + 'px');
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(cmFixRating, 120); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cmFixRating, { once: true });
  } else {
    cmFixRating();
  }
  window.addEventListener('load', cmFixRating, { once: true });
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(cmFixRating);
})();
